<template>
  <div id="UserInfo">
    <loading v-if="loadingRender"></loading>
    <div v-if="!NeedEstelam" class="no-print">
      <panel
        Title="تغییر رمز عبور"
        Des="از طریق این فرم می‌توانید رمز عبور اینترنت بانک خود را تغییر دهید"
        :IsBtnBack="true"
        ClassCustom="bg-dark-Custom text-right mt-2"
      ></panel>
      <div class="row px-3">
        <div class="col-12 col-md-12 mx-md-2 p-md-3">
          <net-pa-card>
            <template slot="header">
              <h6 class="text-right">
                <i class="fas fa-key"></i>
                تغییر رمز عبور
              </h6>
            </template>
            <template slot="content">
              <div class="user-info-change-pass-content">
                <div
                  class="user-info-change-pass-alert alert alert-warning border-warning"
                >
                  <span class="badge badge-warning mb-2 p-1">هشدار امنیتی</span>
                  <ul class="user-info-change-pass-alert__list mb-0">
                    <li>
                      جهت جلوگیری از سوء استفاده، رمز اینترنت بانک خود را هر چند
                      مدت یکبار تعویض نمایید.
                    </li>
                    <li>
                      برای امنیت بیشتر بهتر است رمز اینترنت بانک شما شامل حروف
                      بزرگ و کوچک انگلیسی و اعداد باشد.
                    </li>
                  </ul>
                </div>

                <form id="divpass" class="user-info-change-pass-form">
                  <div class="user-info-change-pass-field">
                    <input
                      type="password"
                      v-model="oldpass"
                      @keypress="$BlockSuspiciousInput($event, 30)"
                      @keyup="$BlockSuspiciousInput($event, 30)"
                      class="form-control text-center"
                      :class="NeedEstelam === 'true' ? '' : 'required'"
                      placeholder="رمز عبور فعلی"
                      autocomplete="off"
                    />
                  </div>
                  <div class="user-info-change-pass-field">
                    <input
                      type="password"
                      @keypress="$BlockSuspiciousInput($event, 30)"
                      @keyup="$BlockSuspiciousInput($event, 30)"
                      v-model="newpass"
                      class="form-control text-center"
                      :class="
                        NeedEstelam === 'true' ? '' : 'required required-Pass'
                      "
                      placeholder="رمز جدید"
                      autocomplete="new-password"
                    />
                  </div>
                  <div class="user-info-change-pass-field">
                    <input
                      type="password"
                      @keypress="$BlockSuspiciousInput($event, 30)"
                      @keyup="$BlockSuspiciousInput($event, 30)"
                      v-model="newpasscomfirm"
                      class="form-control text-center"
                      :class="
                        NeedEstelam === 'true' ? '' : 'required required-Pass'
                      "
                      placeholder="تکرار رمز جدید"
                      autocomplete="new-password"
                    />
                  </div>
                  <div class="user-info-change-pass-actions">
                    <button
                      type="button"
                      class="btn btn-success user-info-change-pass-submit-btn"
                      @click.prevent="ChangePass($event)"
                    >
                      تغییر رمز
                    </button>
                  </div>
                </form>
              </div>
            </template>
          </net-pa-card>
        </div>
      </div>
    </div>
    <div class="no-print">
      <panel
        Title="اطلاعات هویتی"
        Des="اطلاعات شما در این بخش قابل مشاهده است"
        :IsBtnBack="NeedEstelam == 'true'"
        ClassCustom="bg-dark-Custom text-right mt-2"
      ></panel>
      <div class="row px-3">
        <div class="col-12 col-md-12 mx-md-2 p-md-3">
          <div class="row" v-if="NeedEstelam == 'true'">
            <div class="col-12">
              <div class="alert alert-warning text-center">
                <div class="">
                  کاربر گرامی اطلاعات هویتی شما ناقص می باشد ، لطفا موارد خواسته
                  شده را تکمیل کنید
                </div>
              </div>
            </div>
          </div>
          <net-pa-card v-if="EstlamSuccess == false && NeedEstelam == 'true'">
            <template slot="header">
              <h6 class="text-right">
                <i class="fas fa-user-shield"></i> احراز هویت
              </h6>
            </template>
            <template slot="content">
              <div class="row">
                <div class="col-12">
                  <div class="alert alert-info text-center">
                    <h5>
                      برای دریافت کد احراز هویت کد ملی ، شماره موبایل و تاریخ
                      تولد خود را وارد کنید.
                    </h5>
                    <span
                      >برای احراز هویت شما نیاز است شماره موبایل و تاریخ تولد
                      شما با اطلاعات واقعی شما مطابقت داشته باشد
                    </span>
                  </div>
                </div>
                <div class="col-12 user-info-auth-form">
                  <form v-if="stage == 1" :id="'stage' + stage">
                    <input
                      class="form-control text-center required"
                      disabled
                      v-model="DataAxiosEstelamSabtAhval.CodeMeli"
                      type="number"
                      placeholder="کد ملی"
                      autocomplete="off"
                      @keypress="
                        $ValidNumber($event, 10);
                        $BlockSuspiciousInput($event, 10);
                      "
                    />
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <input
                          class="form-control text-center mt-2 required"
                          type="text"
                          id="Mobile"
                          name="Mobile"
                          placeholder="شماره موبایل"
                          autocomplete="off"
                          v-model="DataAxiosEstelamSabtAhval.Mobile"
                          @keypress="
                            $ValidNumber($event, 11);
                            $BlockSuspiciousInput($event, 11);
                          "
                        />
                      </div>
                      <div class="col-md-6 col-12 mt-2">
                        <date-picker
                          input-class="required form-control"
                          :editable="true"
                          color="#ff9800"
                          autocomplete="off"
                          placeholder="تاریخ تولد"
                          v-model="DataAxiosEstelamSabtAhval.BirthDate"
                        ></date-picker>
                      </div>
                    </div>
                    <button
                      class="btn rounded btn-submit w-100 mt-4"
                      @click.prevent="sendSms('stage' + stage)"
                    >
                      ارسال کد احراز هویت
                    </button>
                  </form>
                  <form v-if="stage == 2" :id="'stage' + stage">
                    <small
                      >کد احراز هویت پیامک شده بر روی تلفن همراه خود را وارد
                      نمایید</small
                    >
                    <input
                      class="form-control mt-2 text-center required"
                      placeholder="کد احراز هویت"
                      type="number"
                      @keypress="$ValidNumber($event, 10)"
                      v-model="randomKey"
                    />
                    <button
                      class="btn rounded btn-submit w-100 mt-2"
                      @click.prevent="OkCode('stage' + stage)"
                    >
                      تایید کد پیامکی
                    </button>
                  </form>
                </div>
              </div>
            </template>
          </net-pa-card>

          <net-pa-tab
            v-if="UserTabs.length > 0"
            :Tabs="UserTabs"
            @change="onTabChange"
          ></net-pa-tab>
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-home"
              v-if="showTab(0)"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <net-pa-card :Compact="true">
                <template slot="content">
                  <div class="row user-info-identity-fields" id="userInfoDiv">
                    <div class="col-12 mb-3 text-center user-info-avatar-wrap">
                      <img
                        :src="avatarSrc"
                        alt="تصویر پروفایل"
                        class="user-info-avatar"
                      />
                    </div>
                    <div
                      class="col-12 mt-2 mb-4 text-center"
                      v-if="
                        $session.get('UserInfoNetPa').isEstelamSabtAhval ==
                          true && IsrequiredEstelamSabtAhval == 'true'
                      "
                    >
                      <div class="row">
                        <div class="col-md-4 col-12 text-md-left text-center">
                          <i class="fas fa-user-shield text-success fa-5x"></i>
                        </div>
                        <div
                          class="col-md-8 col-12 text-md-right text-center mt-2"
                        >
                          <h5 class="mx-2 text-success mb-2">
                            احراز هویت با موفقیت انجام شده
                          </h5>
                          <h7 class="mx-2 text-success mb-2"
                            >اطلاعات هویتی شما (توسط سامانه ثبت احوال) مورد
                            تایید می‌باشد</h7
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-12 my-1">
                      <small>نام</small>
                      <input
                        type="text"
                        :disabled="
                          !canChange.canChangeOzvName || FixInput == true
                        "
                        class="form-control"
                        placeholder="نام"
                        v-model="UserInfo.ozvName"
                        @keypress="$BlockSuspiciousInput($event, 30)"
                      />
                    </div>
                    <div class="col-md-4 col-12 my-1">
                      <small>نام خانوادگی</small>
                      <input
                        type="text"
                        :disabled="
                          !canChange.canChangeOzvFamily || FixInput == true
                        "
                        class="form-control text-right"
                        placeholder="نام خانوادگی"
                        v-model="UserInfo.ozvFamily"
                        @keypress="$BlockSuspiciousInput($event, 40)"
                      />
                    </div>
                    <div class="col-md-4 col-12 my-1">
                      <small>کد ملی</small>
                      <input
                        type="text"
                        :disabled="
                          !canChange.canChangeCodeMeli || FixInput == true
                        "
                        class="form-control text-left required-CodeMeli"
                        placeholder="کد ملی"
                        v-model="UserInfo.codeMeli"
                        @keypress="$BlockSuspiciousInput($event, 10)"
                      />
                    </div>
                    <div class="col-md-4 col-12 my-1">
                      <small>شماره عضویت</small>
                      <input
                        type="text"
                        disabled
                        class="form-control text-left"
                        placeholder="شماره مشتری"
                        v-model="UserInfo.shomareOzv"
                        @keypress="$BlockSuspiciousInput($event, 30)"
                      />
                    </div>
                    <div class="col-md-4 col-12 my-1">
                      <small>شماره همراه</small>
                      <input
                        type="text"
                        :disabled="
                          !canChange.canChangeMobile || FixInput == true
                        "
                        class="form-control text-left"
                        placeholder="شماره همراه"
                        v-model="UserInfo.mobile"
                        @keypress="$BlockSuspiciousInput($event, 11)"
                      />
                    </div>
                    <div class="col-md-4 col-12 my-1">
                      <small>تلفن</small>
                      <input
                        type="text"
                        :disabled="!canChange.canChangeTel"
                        class="form-control text-left"
                        placeholder="تلفن ثابت"
                        v-model="UserInfo.tel"
                        @keypress="$BlockSuspiciousInput($event, 15)"
                      />
                    </div>
                    <div class="col-md-4 col-12 my-1">
                      <small>تاریخ تولد</small>
                      <date-picker
                        :editable="true"
                        :disabled="
                          !canChange.canChangeBirthDate || FixInput == true
                        "
                        :auto-submit="true"
                        color="#ff9800"
                        v-model="UserInfo.birthDate"
                      ></date-picker>
                      <input
                        type="text text-left"
                        :disabled="
                          !canChange.canChangeBirthDate || FixInput == true
                        "
                        tabindex="-1"
                        class="d-none InputText"
                        style="direction: ltr"
                      />
                    </div>
                    <div class="col-md-4 col-12 my-1">
                      <small>نام پدر</small>
                      <input
                        type="text"
                        class="form-control"
                        :disabled="
                          !canChange.canChangePedar || FixInput == true
                        "
                        placeholder="نام پدر"
                        v-model="UserInfo.pedar"
                        @keypress="$BlockSuspiciousInput($event, 20)"
                      />
                    </div>
                    <div class="col-md-4 col-12 my-1">
                      <small>شماره شناسنامه</small>
                      <input
                        type="text"
                        class="form-control text-left required"
                        :disabled="!canChange.canChangeShenasname"
                        placeholder="شماره شناسنامه"
                        v-model="UserInfo.shenasname"
                        @keypress="$BlockSuspiciousInput($event, 15)"
                      />
                    </div>
                    <div class="col-12 col-md-4 my-1">
                      <small>آدرس ایمیل</small>
                      <input
                        type="text"
                        class="form-control text-left"
                        dir="ltr"
                        :disabled="!canChange.canChangeEmail"
                        placeholder="ایمیل"
                        v-model="UserInfo.email"
                        @keypress="$BlockSuspiciousInput($event, 40)"
                      />
                    </div>
                    <div class="col-md-8 col-12 my-1">
                      <small>آدرس</small>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="آدرس"
                        :disabled="!canChange.canChangeAdres"
                        v-model="UserInfo.adres"
                        @keypress="$BlockSuspiciousInput($event, 300)"
                      />
                    </div>
                    <div
                      class="col-md-4 col-12 my-1"
                      v-if="$session.get('CustCode') != '932'"
                    >
                      <small>سال ورود به سازمان</small>
                      <input
                        type="text"
                        :disabled="true"
                        class="form-control"
                        placeholder="سال ورود"
                        v-model="UserInfo.tarixEmp"
                      />
                    </div>
                    <div
                      class="col-md-4 col-12 my-1"
                      v-if="$session.get('CustCode') != '932'"
                    >
                      <small> رسته خدمت</small>
                      <input
                        type="text"
                        :disabled="true"
                        class="form-control"
                        placeholder="رسته خدمت"
                      />
                    </div>
                    <div
                      class="col-md-4 col-12 my-1"
                      v-if="$session.get('CustCode') != '932'"
                    >
                      <small> مدرک تحصیلی</small>
                      <input
                        type="text"
                        :disabled="true"
                        class="form-control"
                        placeholder="مدرک تحصیلی"
                        v-model="UserInfo.tblComboIdTahsilat316"
                      />
                    </div>
                    <div
                      class="col-md-4 col-12 my-1"
                      v-if="$session.get('CustCode') != '932'"
                    >
                      <small> محل کار</small>
                      <input
                        type="text"
                        :disabled="$session.get('CustCode') != 886"
                        class="form-control"
                        placeholder=" محل کار"
                        v-model="UserInfo.mahalKar"
                      />
                    </div>
                    <div
                      class="col-md-4 col-12 my-1"
                      v-if="$session.get('CustCode') != '932'"
                    >
                      <small>سنوات خدمت(ماه-سال)</small>
                      <input
                        type="text"
                        :disabled="true"
                        class="form-control"
                        placeholder="سنوات"
                        :value="
                          UserInfo.sanavatSal == null
                            ? 0
                            : UserInfo.sanavatSal + '-' + UserInfo.sanavatMah ==
                              null
                            ? 0
                            : UserInfo.sanavatMah
                        "
                      />
                    </div>
                    <div
                      class="col-md-4 col-12 my-1"
                      v-if="$session.get('CustCode') != '932'"
                    >
                      <small>نوع اشتغال</small>
                      <SelectCombo
                        @result="getSelectedCombo"
                        :grp="24"
                        :defaultItemId="UserInfo.comboIdNoeEstekhdam33"
                        :disabled="FixInput == true"
                      ></SelectCombo>
                      <!-- <input type="text" :disabled="$session.get('CustCode') != 886" class="form-control" placeholder=" نوع اشتغال" v-model="UserInfo.ComboIdNoeEstekhdam33" /> -->
                    </div>
                    <div
                      class="col-md-4 col-12 my-1"
                      v-if="$session.get('CustCode') != '932'"
                    >
                      <small> شهر محل خدمت </small>
                      <input
                        type="text"
                        :disabled="true"
                        class="form-control"
                        placeholder=" شهر محل خدمت"
                        v-model="UserInfo.tblComboIdGrp11WorkCity"
                      />
                    </div>
                    <div
                      class="col-md-4 col-12 my-1"
                      v-if="$session.get('CustCode') != '932'"
                    >
                      <small>محل تولد</small>
                      <input
                        type="text"
                        :disabled="true"
                        class="form-control"
                        placeholder="محل تولد"
                        v-model="UserInfo.mahalSodor"
                      />
                    </div>
                    <div
                      class="col-md-4 col-12 my-1"
                      v-if="$session.get('CustCode') != '932'"
                    >
                      <small>رسته سازمانی</small>
                      <input
                        type="text"
                        :disabled="true"
                        class="form-control"
                        placeholder="رسته سازمانی"
                        v-model="UserInfo.rasteSazmani"
                      />
                    </div>
                    <div
                      class="col-md-4 col-12 my-1"
                      v-if="$session.get('CustCode') != '932'"
                    >
                      <small>پست سازمانی</small>
                      <input
                        type="text"
                        :disabled="$session.get('CustCode') != 886"
                        class="form-control"
                        placeholder="پست سازمانی"
                        v-model="UserInfo.postSazmani"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-8 col-12"></div>
                    <div class="col-md-4 col-12 float-left">
                      <!--<div class="d-flex col-12 justify-content-end mt-2">-->
                      <button
                        v-if="$session.get('UserInfoNetPa').cId != '801'"
                        class="btn rounded btn-success float-left mt-2 w-100"
                        @click="UpdateUser()"
                      >
                        ثبت تغییرات
                      </button>
                    </div>
                  </div>
                </template>
              </net-pa-card>
            </div>
            <div
              class="tab-pane fade"
              id="nav-BankAccount"
              role="tabpanel"
              aria-labelledby="nav-BankAccount-tab"
            >
              <net-pa-card :Compact="true">
                <template slot="content">
                  <button
                    v-if="addBankAccount == false"
                    class="btn rounded btn-success my-2"
                    @click="addBankAccount = true"
                  >
                    اضافه کردن حساب بانکی
                  </button>

                  <vue-bootstrap4-table
                    :rows="rows"
                    :columns="columns"
                    :config="config"
                    :classes="classes"
                    v-if="addBankAccount == false"
                  >
                    <template slot="sort-asc-icon">
                      <i class="fa fa-sort-up"></i>
                    </template>
                    <template slot="shebaNo" slot-scope="props">
                      <span dir="ltr">{{ props.row.shebaNo }}</span>
                    </template>
                    <template slot="sort-desc-icon">
                      <i class="fa fa-sort-down"></i>
                    </template>
                    <template slot="no-sort-icon">
                      <i class="fa fa-sort"></i>
                    </template>
                    <template slot="empty-results">
                      <p class="text-right">اطلاعاتی یافت نشد</p>
                    </template>
                    <template slot="edit" slot-scope="props">
                      <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        @click="GEtAzaHesab(props.row.id)"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                    </template>
                  </vue-bootstrap4-table>

                  <div v-else class="user-info-bank-add">
                    <div class="row user-info-bank-form" id="addAccountBank">
                      <div
                        class="col-md-4 col-12 user-info-bank-field"
                        v-if="$session.get('CustCode') != '932'"
                      >
                        <small class="user-info-bank-label">شماره شبا</small>
                        <div class="user-info-sheba-input">
                          <span class="user-info-sheba-prefix">IR</span>
                          <input
                            type="text"
                            class="form-control required user-info-bank-input"
                            dir="ltr"
                            @keypress="
                              $ValidNumber($event, 24);
                              $BlockSuspiciousInput($event, 24);
                            "
                            @keydown="$BlockSuspiciousInput($event, 24)"
                            v-model="bankAcoount.ShebaNo"
                            autocomplete="off"
                          />
                        </div>
                      </div>

                      <div class="col-md-4 col-12 user-info-bank-field">
                        <small class="user-info-bank-label"
                          >نام صاحب حساب</small
                        >
                        <input
                          type="text"
                          class="form-control required user-info-bank-input"
                          v-model="bankAcoount.NameSahebHesab"
                          :disabled="FixInput"
                          @keypress="$BlockSuspiciousInput($event, 20)"
                        />
                      </div>
                      <div
                        class="col-md-4 col-12 user-info-bank-field"
                        v-if="
                          $session.get('CustCode') != '932' &&
                          $session.get('CustCode') != 948
                        "
                      >
                        <small class="user-info-bank-label">شماره کارت</small>
                        <input
                          type="text"
                          class="form-control required user-info-bank-input"
                          dir="ltr"
                          @keypress="
                            $ValidNumber($event, 16);
                            $BlockSuspiciousInput($event, 16);
                          "
                          @keydown="$BlockSuspiciousInput($event, 16)"
                          v-model="bankAcoount.CardNo"
                        />
                      </div>
                      <div
                        class="col-md-4 col-12 user-info-bank-field"
                        v-if="$session.get('CustCode') != 948"
                      >
                        <small class="user-info-bank-label">شماره حساب</small>
                        <input
                          v-if="$session.get('CustCode') != 932"
                          type="text"
                          class="form-control required user-info-bank-input"
                          dir="ltr"
                          v-model="bankAcoount.HesabNo"
                          @keypress="
                            $ValidNumber($event, 15, false);
                            $BlockSuspiciousInput($event, 15);
                          "
                          @keydown="$BlockSuspiciousInput($event, 15)"
                        />
                        <input
                          v-else
                          type="text"
                          class="form-control required user-info-bank-input"
                          dir="ltr"
                          v-model="bankAcoount.HesabNo"
                          @keypress="
                            $ValidNumber($event, 12, false);
                            $BlockSuspiciousInput($event, 12);
                          "
                          @keydown="$BlockSuspiciousInput($event, 12)"
                        />
                      </div>

                      <!-- <div class="col-md-4 col-12 user-info-bank-field">
                        <small class="user-info-bank-label">فعال</small>
                        <input type="checkbox" class="form-control"
                          v-model="bankAcoount.Active" />
                      </div> -->

                      <div class="col-md-4 col-12 user-info-bank-field">
                        <small class="user-info-bank-label">بانک</small>
                        <SelectCombo
                          class="user-info-bank-select"
                          @result="getSelectedBank"
                          :readFromAction="'SelAzaHesab/GetBanks'"
                          :isRequired="true"
                          :defaultItemText="bankAcoount.bankName"
                        ></SelectCombo>
                      </div>

                      <div class="col-md-4 col-12 user-info-bank-field">
                        <small class="user-info-bank-label">وضعیت</small>
                        <div class="form-control text-center">
                          <div class="custom-control custom-switch">
                            <h6 id="LbltblComboGrpId50" class="d-inline">
                              فعال
                            </h6>
                            <input
                              type="checkbox"
                              class="custom-control-input required InputText"
                              id="AccountStatus"
                              v-model="bankAcoount.Active"
                            />
                            <label
                              class="custom-control-label"
                              for="AccountStatus"
                            >
                            </label>
                            <h6 class="mr-5 d-inline">غیر فعال</h6>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="user-info-bank-actions">
                      <button
                        v-if="editHesabMode == false"
                        type="button"
                        class="btn rounded btn-success user-info-bank-actions__btn"
                        @click="submitBankAcoount()"
                      >
                        ثبت
                      </button>
                      <button
                        v-else
                        type="button"
                        class="btn rounded btn-success user-info-bank-actions__btn"
                        @click="editBankAcoount()"
                      >
                        ویرایش
                      </button>
                      <button
                        type="button"
                        class="btn rounded btn-danger user-info-bank-actions__btn"
                        @click="
                          addBankAccount = false;
                          changeEditHesabMode(false);
                        "
                      >
                        لغو
                      </button>
                    </div>
                  </div>
                </template>
              </net-pa-card>
            </div>
            <!--original place-->
            <div
              class="tab-pane fade user-info-docs-tab"
              id="nav-file"
              role="tabpanel"
              aria-labelledby="nav-file-tab"
            >
              <net-pa-card :Compact="true">
                <template slot="content">
                  <div class="user-info-docs-grid">
                    <div class="user-info-doc-card">
                      <uploader
                        :Idu="'shenasname1'"
                        v-if="$store.state.renderComponent"
                        :base64="GetBase(181070505)"
                        @Done="GetFile"
                        :attachId="GetId(181070505)"
                        :address="GetAddress(181070505)"
                        :grp="181070505"
                        :title="'صفحه اول شناسنامه'"
                        :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                      ></uploader>
                    </div>
                    <div class="user-info-doc-card">
                      <uploader
                        :Idu="'shenasname2'"
                        :base64="GetBase(181070506)"
                        @Done="GetFile"
                        v-if="$store.state.renderComponent"
                        :attachId="GetId(181070506)"
                        :address="GetAddress(181070506)"
                        :grp="181070506"
                        :title="'صفحه دوم شناسنامه'"
                        :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                      ></uploader>
                    </div>
                    <div class="user-info-doc-card">
                      <uploader
                        :Idu="'cartmeli1'"
                        @Done="GetFile"
                        :base64="GetBase(181070507)"
                        v-if="$store.state.renderComponent"
                        :attachId="GetId(181070507)"
                        :address="GetAddress(181070507)"
                        :grp="181070507"
                        :title="'تصویر جلوی کارت ملی'"
                        :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                      ></uploader>
                    </div>
                    <div class="user-info-doc-card">
                      <uploader
                        :Idu="'cartmeli2'"
                        :base64="GetBase(181070508)"
                        @Done="GetFile"
                        v-if="$store.state.renderComponent"
                        :attachId="GetId(181070508)"
                        :address="GetAddress(181070508)"
                        :grp="181070508"
                        :title="'تصویر پشت کارت ملی'"
                        :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                      ></uploader>
                    </div>
                    <div class="user-info-doc-card">
                      <uploader
                        :Idu="'others'"
                        @Done="GetFile"
                        :base64="GetBase(181070509)"
                        v-if="$store.state.renderComponent"
                        :attachId="GetId(181070509)"
                        :address="GetAddress(181070509)"
                        :grp="181070509"
                        :title="'سایر مدارک'"
                        :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                      ></uploader>
                    </div>
                  </div>
                </template>
              </net-pa-card>
            </div>
            <div
              class="tab-pane fade"
              id="nav-Isar"
              role="tabpanel"
              aria-labelledby="nav-Isar-tab"
            >
              <net-pa-card :Compact="true">
                <template slot="content">
                  <div class="row">
                    <div class="col-12">
                      <vue-bootstrap4-table
                        :rows="rowsIsar"
                        :columns="columnsIsar"
                        :config="config"
                        :classes="classes"
                        v-if="showIsarTable"
                      >
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>

                        <template slot="isBaradarShahid" slot-scope="props">
                          <i
                            v-if="props.row.isBaradarShahid"
                            class="fas fa-check text-success"
                          ></i>
                          <i v-else class="fas fa-times text-danger"></i>
                        </template>
                        <template slot="isKhanevadeShahid" slot-scope="props">
                          <i
                            v-if="props.row.isKhanevadeShahid"
                            class="fas fa-check text-success"
                          ></i>
                          <i v-else class="fas fa-times text-danger"></i>
                        </template>
                        <template slot="isRazmande" slot-scope="props">
                          <i
                            v-if="props.row.isRazmande"
                            class="fas fa-check text-success"
                          ></i>
                          <i v-else class="fas fa-times text-danger"></i>
                        </template>
                        <template slot="isJanbaz" slot-scope="props">
                          <i
                            v-if="props.row.isJanbaz"
                            class="fas fa-check text-success"
                          ></i>
                          <i v-else class="fas fa-times text-danger"></i>
                        </template>
                        <template slot="isAzade" slot-scope="props">
                          <i
                            v-if="props.row.isAzade"
                            class="fas fa-check text-success"
                          ></i>
                          <i v-else class="fas fa-times text-danger"></i>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </template>
              </net-pa-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import NetPaTab from "../Tools/NetPa/NetPaTab.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import loading from "../Tools/NetPa/Loading.vue";
import uploader from "./Componenets/NetpaUploader.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import SelectCombo from "@/components/Tools/SelectCombo.vue";
export default {
  data() {
    return {
      //AccountStatus: true,
      showIsarTable: false,
      editHesabMode: false,
      IsrequiredEstelamSabtAhval: false,
      EstelamSabtAhvalIsSuccess: false,
      DataAxiosEstelamSabtAhval: {
        CodeMeli: "",
        Mobile: "",
        BirthDate: "",
        CustCode: this.$session.get("CustCode"),
      },
      // DataAxiosEstelamSabtAhval: { CodeMeli: '', Mobile: '', BirthDate: '', CustCode: 7777 },
      stage: 1,
      ResultStage1: {},
      ResultStage2: {},
      randomKey: null,
      FixInput: false,
      value: null,
      file: [],
      UserInfo: {},
      defaultAvatar: "/Template/NewMenu/img/userNew.jpg",
      bankAcoount: { NameSahebHesab: "", Active: true },
      newpass: "",
      oldpass: "",
      addBankAccount: false,
      canChange: {},
      newpasscomfirm: "",
      DataAxiosChange: {
        ArryfildValue: "",
        Method: "Post",
        Action: "UpdPass/netpaUpdPass",
        Token: this.$session.get("TokenNetPa"),
      },
      loadingRender: false,
      rows: [],
      columns: [
        { label: "نام صاحب حساب", name: "nameSahebHesab" },
        { label: "نام بانک ", name: "bankName" },
        { label: "شماره حساب", name: "hesabNo" },
        { label: "شماره کارت", name: "cardNo" },
        { label: "شماره شبا", name: "shebaNo" },
        { label: "ویرایش", name: "edit" },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: "  جستجو   ",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      columnsIsar: [
        { label: "آزادگی", name: "isAzade" },
        { label: "جانبازی", name: "isJanbaz" },
        { label: "رزمنده", name: "isRazmande" },
        { label: "مدت اسارت (سال)", name: "salEsarat" },
        { label: "درصد جانبازی", name: "darsadJanbazi" },
        { label: "تعداد ماه عملیات", name: "mahAmaliyat" },
        { label: "خانواده شهید", name: "isKhanevadeShahid" },
        { label: "برادر شهید", name: "isBaradarShahid" },
      ],
      rowsIsar: [],
      tabMenus: this.$session
        .get("AccessMenu")
        .filter((x) => x.routeName == "Tab"),
      EstlamSuccess: false,
    };
  },
  components: {
    VueBootstrap4Table,
    NetPaCard,
    NetPaTab,
    Panel,
    loading,
    uploader,
    SelectCombo,
  },
  created() {
    this.changeEditHesabMode(false);
    this.IsrequiredEstelamSabtAhval = this.$GetIsrequiredEstelamSabtAhval();

    if (this.NeedEstelam === "true") {
      this.DataAxiosEstelamSabtAhval.CodeMeli = this.$session
        .get("UserInfoNetPa")
        .codeMeli.trim();
    }
    if (
      this.$session.get("CustCode") == "932" ||
      this.$session.get("CustCode") == "8002" ||
      this.$session.get("CustCode") == "953"
    ) {
      this.FixInput = true;
      this.bankAcoount.NameSahebHesab =
        this.$session.get("UserInfoNetPa").ozvName +
        " " +
        this.$session.get("UserInfoNetPa").ozvFamily;
    }
    if (this.$session.get("CustCode") == 948) {
      this.FixInput = true;
    }
    this.getAzaNoe();
    // this.UserInfo = JSON.parse(JSON.stringify(this.$session.get('UserInfoNetPa')))
    // this.UserInfo.codeMeli = this.UserInfo.codeMeli.trim()
    // this.UserInfo.shomareOzv = this.UserInfo.shomareOzv.trim()

    this.GetOzv();
    this.$FetchAzaPic();
    this.GEtAzaHesab();
    this.GEtAzaIsar();
  },
  mounted() {
    this.GetFile();
    if (this.$route.query.autoClick === "true") {
      document.getElementById("nav-BankAccount-tab").click();
    }
  },
  methods: {
    onTabChange(id) {
      this.showIsarTable = id == "nav-Isar";
    },
    changeEditHesabMode(status) {
      this.editHesabMode = status;
      if (!status) {
        this.bankAcoount.ShebaNo = "";
        this.bankAcoount.HesabNo = "";
        this.bankAcoount.CardNo = "";
        this.bankAcoount.bankName = "";
        this.bankAcoount.Active = true;
      }
    },
    submitBankAcoount() {
      if (this.$session.get("CustCode") == 948) {
        this.Estelam().then((res) => {
          // this.bankAcoount.NameSahebHesab=res
          this.$mySweetDefaultTost(
            "استعلام موفق",
            "استعلام شماره شبا با موفقیت انجام شد",
            "success",
            2000,
          );
          if (!this.$ValidForm("addAccountBank")) {
            return;
          } else {
            this.AddOrEditAzaHesab(false);
            return;
          }
        });
      } else {
        if (
          !this.$ValidForm("addAccountBank") &&
          (this.$session.get("CustCode") == "932" ||
            this.$session.get("CustCode") == 948)
        ) {
          return;
        }
        this.AddOrEditAzaHesab(false);
      }
    },
    editBankAcoount() {
      if (this.$session.get("CustCode") == 948) {
        this.Estelam().then((res) => {
          // this.bankAcoount.NameSahebHesab=res
          this.$mySweetDefaultTost(
            "استعلام موفق",
            "استعلام شماره شبا با موفقیت انجام شد",
            "success",
            2000,
          );
          if (!this.$ValidForm("addAccountBank")) {
            return;
          } else {
            this.AddOrEditAzaHesab(true);
            return;
          }
        });
      } else {
        if (
          !this.$ValidForm("addAccountBank") &&
          (this.$session.get("CustCode") == "932" ||
            this.$session.get("CustCode") == 948)
        ) {
          return;
        }
        this.AddOrEditAzaHesab(true);
      }
    },
    AddOrEditAzaHesab(isEdit) {
      // this.bankAcoount.Active = this.AccountStatus;
      if (
        this.$session.get("CustCode") != "932" &&
        this.bankAcoount.ShebaNo.length != 24
      ) {
        this.$mySweetDefaultTost(
          "",
          "شماره شبا باید 24 رقم باشد",
          "error",
          3000,
        );
        return;
      }
      if (
        this.$session.get("CustCode") != "932" &&
        this.$session.get("CustCode") != "948" &&
        this.bankAcoount.CardNo.length != 16
      ) {
        this.$mySweetDefaultTost(
          "",
          "شماره کارت باید 16 رقم باشد",
          "error",
          3000,
        );
        return;
      }
      if (
        this.$session.get("CustCode") != "948" &&
        this.$session.get("CustCode") != "932" &&
        this.bankAcoount.HesabNo.length < 5
      ) {
        this.$mySweetDefaultTost("", "شماره حساب مجاز نیست", "error", 3000);
        return;
      }

      if (
        this.$session.get("CustCode") == "932" &&
        (this.bankAcoount.HesabNo.length < 5 ||
          this.bankAcoount.HesabNo.length > 12)
      ) {
        this.$mySweetDefaultTost("", "شماره حساب مجاز نیست", "error", 3000);
        return;
      }
      if (!isEdit) {
        this.$PostData_new(
          "SelAzaHesab/AddBankAccount",
          "post",
          this.bankAcoount,
        )
          .then((res) => {
            if (res.data == false) {
              this.$mySweetDefaultTost(
                "",
                "در ثبت اطلاعات مشکلی پیش آمده لطفا مجددا تلاش کنید ",
                "warning",
                3000,
              );
            } else {
              this.$mySweetDefaultTost(
                "",
                "اطلاعات با موفقیت افزوده شد",
                "success",
                2000,
              );
              this.GEtAzaHesab();
              this.addBankAccount = false;
            }
          })
          .catch((err) => {
            this.$mySweetDefaultTost("", "خطای سمت سرور", "error", 2000);
            console.error("e", err);
          });
      } else {
        this.$PostData_new(
          "SelAzaHesab/EditBankAccount",
          "post",
          this.bankAcoount,
        )
          .then((res) => {
            if (res.data == false) {
              this.$mySweetDefaultTost(
                "",
                "در ویرایش اطلاعات مشکلی پیش آمده لطفا مجددا تلاش کنید ",
                "warning",
                3000,
              );
            } else {
              this.$mySweetDefaultTost(
                "",
                "اطلاعات با موفقیت ویرایش شد",
                "success",
                2000,
              );
              this.GEtAzaHesab();
              this.addBankAccount = false;
            }
          })
          .catch((err) => {
            this.$mySweetDefaultTost("", "خطای سمت سرور", "error", 2000);
            console.error("e", err);
          });
      }
    },
    // دسترسی نمایش تب ها که از جدول wwwtblMenu میخونه
    showTab(num) {
      try {
        let tab = this.tabMenus.find((x) => x.params == num);
        if (num != 0 && num != 1 && this.NeedEstelam === "true") {
          return false;
        }
        if (
          (num == 0 || num == 1) &&
          this.NeedEstelam === "true" &&
          this.EstlamSuccess == false
        ) {
          return false;
        }
        return tab.isMenu;
      } catch (err) {
        console.error("e", err);
        return true;
      }
    },
    bankAccountChange(add) {
      this.addBankAccount = add;
    },
    Estelam() {
      return new Promise((success, reject) => {
        this.loadingRender = true;

        var data = {
          CustCode: this.$session.get("CustCode"),
          Sign: "",
          IbanNumber: "IR" + this.bankAcoount.ShebaNo,
        };
        var EstelamAxios = {
          action: "EstelamSheba/Index",
          method: "POST",
          arryfildValue: data,
        };

        this.$PostData_netpatoken(EstelamAxios)
          .then((result) => {
            if (typeof result == "string" || result.isSuccess == false) {
              var message = result == "string" ? result : result.message;
              this.$mySweetDefault("خطا", message, "error", 2000);
              this.bankAcoount.NameSahebHesab = "";
            } else {
              let FName = String(
                result.ibanAccountOwnerList[0].firstName +
                  " " +
                  result.ibanAccountOwnerList[0].lastName,
              );
              this.bankAcoount.NameSahebHesab = FName;
              success(FName);
            }
          })
          .finally(() => {
            this.loadingRender = false;
          });
      });
    },
    GetAddress(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        if (
          binary.filename.indexOf(".PDF") > 0 ||
          binary.filename.indexOf(".pdf") > 0
        ) {
          return "/Image/PdfFile.png";
        }
        if (
          binary.filename.indexOf(".zip") > 0 ||
          binary.filename.indexOf(".rar") > 0
        ) {
          return "/Image/ZipFile.png";
        }
        return "data:image/png;base64," + binary.binary;
      } else {
        return null;
      }
    },
    GetId(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        return binary.id;
      } else {
        return null;
      }
    },
    GetFile() {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
          tableName: "wwwtblaza",
        },
      };
      this.$PostData(dataAxios).then((result) => {
        if (result.data !== undefined) {
          this.file = result.data;
          this.$store.state.renderComponent = false;
          this.$nextTick(() => {
            this.$store.state.renderComponent = true;
          });
        } else {
          this.file = [];
        }
      });
    },
    getSelectedBank(item) {
      this.bankAcoount.WwwtblBankId = item.bnpcashDbId;
    },
    ChangePass() {
      if (this.$ValidForm("divpass")) {
        if (this.newpasscomfirm == this.newpass) {
          this.loadingRender = true;
          const formData = new FormData();
          formData.append(
            "CustCode",
            this.$session.get("UserInfoNetPa").custCode,
          );
          formData.append(
            "CodeMeli",
            this.$session.get("UserInfoNetPa").codemeli,
          );
          formData.append("AxarinTaghirPass", this.$store.state.JalaliDate);
          formData.append("wwwtblazaId", this.$session.get("UserInfoNetPa").id);
          formData.append("NewPassword", this.$Encryption(this.newpass));
          formData.append("OldPass", this.$Encryption(this.oldpass));

          this.DataAxiosChange.ArryfildValue = formData;
          this.$PostFormData(this.DataAxiosChange).then((data) => {
            if (data.status) {
              this.$mySweetDefaultTost("خطا", data.msg, "warning", 2000);
              this.loadingRender = false;
            } else {
              if (data.id) {
                this.$mySweetDefaultTost(
                  "عملیات موفق",
                  "تغییر رمز با موفقیت انجام شد",
                  "success",
                  4000,
                );
                this.loadingRender = false;
                this.$router.push("/PishkhanNetPa/Home");
              }
            }
          });
        } else {
          this.$mySweetDefaultTost(
            "خطا",
            "رمز عبور وارد شده و تکرارش برابر نیستند!",
            "warning",
            2000,
          );
        }
      }
    },
    getSelectedCombo(item) {
      this.UserInfo.comboIdNoeEstekhdam33 = item.id;
    },
    UpdateUser() {
      if (this.$ValidForm("userInfoDiv")) {
        if (this.rows.length == 0 && this.NeedEstelam) {
          this.$mySweetDefaultTost(
            "عدم ثبت اطلاعات",
            "اطلاعات حساب بانکی یافت نشد لطفا اطلاعات حساب بانکی خودرا وارد نمایید",
            "warning",
            4000,
          );
          return;
        }
        this.$RemoveAlert("از صحت اطلاعات اطمینان دارید").then((res) => {
          if (res) {
            var form_data = new FormData();
            for (var key in this.UserInfo) {
              form_data.append(key, this.UserInfo[key]);
            }
            form_data.append(
              "IsEstelamSabtAhval",
              this.NeedEstelam === "true" ? true : null,
            );
            var DataAxiosUpdate = {
              ArryfildValue: form_data,
              Method: "Post",
              Action: "UpdAza",
              Token: this.$session.get("TokenNetPa"),
            };
            this.$PostFormData(DataAxiosUpdate).then((data) => {
              if (data.id) {
                if (this.NeedEstelam === "true") {
                  this.$mySweetDefault(
                    "عملیات موفق",
                    "احراز هویت شما با موفقیت انجام شد و اطلاعات شما بروز گردید ، لطفا جهت بروزرسانی اطلاعات شما دوباره وارد سیستم شوید",
                    "success",
                    4000,
                  );
                  this.LogOut();
                  return;
                }
                this.$mySweetDefaultTost(
                  "عملیات موفق",
                  "اطلاعات با موفقیت بروز شدند",
                  "success",
                  2000,
                );
              } else {
                this.$mySweetDefaultTost(
                  "عملیات ناموفق",
                  "مشکلی در ثبت اطلاعات بوجود آمده است. دوباره تلاش کنید",
                  "error",
                  2000,
                );
              }
            });
          }
        });
      }
    },
    getAzaNoe() {
      var formdata = new FormData();
      formdata.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      formdata.append(
        "wwwtblAzaNoeId",
        this.$session.get("UserInfoNetPa").wwwtblAzaNoeId,
      );
      var DataAxiosUpdate = {
        ArryfildValue: formdata,
        Method: "POST",
        Action: "Dastresi",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxiosUpdate).then((data) => {
        if (this.$session.get("UserInfoNetPa").cId != "801") {
          this.canChange = data;
        }
      });
    },
    checkregex(e) {
      let char = String.fromCharCode(e.keyCode);
      if (!/^[A-Za-z0-9]+$/.test(char)) {
        this.$mySweetDefaultTost(
          "خطا",
          "فقط حروف انگلیسی و اعداد  مجاز هستند",
          "error",
          2000,
        );
        e.preventDefault();
      }
    },
    GetBase(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        return binary;
      } else {
        return null;
      }
    },
    GetOzv() {
      var formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      var DataAxios = {
        Method: "Post",
        Action: "SelAza",
        ArryfildValue: formData,
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios).then((result) => {
        this.UserInfo = result;
        this.UserInfo.codeMeli = this.UserInfo.codeMeli.trim();
        this.UserInfo.shomareOzv = this.UserInfo.shomareOzv.trim();
      });
    },
    GEtAzaHesab(hesabId) {
      var formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      var DataAxios = {
        Method: "Post",
        Action: "SelAzaHesab",
        ArryfildValue: formData,
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios).then((result) => {
        if (hesabId == null) {
          this.rows = result;
        } else {
          var x = result.find((x) => x.id === hesabId);
          this.bankAcoount.ShebaNo =
            x.shebaNo === null || x.shebaNo == ""
              ? x.shebaNo
              : x.shebaNo.trim().replace(/^IR/, "");
          this.bankAcoount.HesabNo =
            x.hesabNo === null || x.hesabNo == ""
              ? x.hesabNo
              : x.hesabNo.trim();
          this.bankAcoount.CardNo =
            x.cardNo === null || x.cardNo == "" ? x.cardNo : x.cardNo.trim();
          this.bankAcoount.bankName =
            x.bankName === null || x.bankName == ""
              ? x.bankName
              : x.bankName.trim();
          this.bankAcoount.Id = x.id;
          this.bankAcoount.Active = x.active;
          this.changeEditHesabMode(true);
          this.addBankAccount = true;
        }
      });
    },
    GEtAzaIsar() {
      var formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      var DataAxios = {
        Method: "Post",
        Action: "IsarGari",
        ArryfildValue: formData,
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios).then((result) => {
        this.rowsIsar = result;
      });
    },
    sendSms(IdFormValid) {
      if (!this.$ValidForm(IdFormValid)) {
        return;
      }

      this.loadingRender = true;
      this.$PostData_new(
        "GetInfocodeMeli",
        "POST",
        this.DataAxiosEstelamSabtAhval,
      ).then((re) => {
        // console.log("😂 ~ re:", re)
        if (re.result == "false") {
          this.$mySweetDefaultTost("خطا", re.msg, "error", 3800);
        }
        if (re.result == "faild") {
          this.$mySweetDefaultTost("عدم احراز هویت", re.msg, "warning", 4500);
        }
        if (re.result == "success" && re.type == "2") {
          this.ResultStage1 = re;
          this.stage = 2;
          this.$mySweetDefaultTost(
            "ارسال موفق",
            "کد احراز هویت برای شما پیامک شد ، دریافت کد به علت ترافیک پیامک ها ممکن است کمی زمان بر باشد",
            "success",
            4500,
          );
        }
        if (re.result == "success" && re.type == "1") {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            "احراز موفق",
            "کاربر گرامی : " +
              re.data.name +
              " " +
              re.data.family +
              " احراز هویت شما با موفقیت انجام گردید ",
            "success",
            4800,
          );
          this.stage = 3;
          this.ResultStage2 = re.data;
          this.EstlamSuccess = true;
          this.FixInput = true;
          this.UserInfo.ozvName = re.data.name;
          this.UserInfo.ozvFamily = re.data.family;
          this.UserInfo.codeMeli = re.data.idCode;
          this.UserInfo.birthDate = re.data.birthDate;
          this.UserInfo.mobile = re.data.mobile;
          this.UserInfo.pedar = re.data.fatherName;
          this.UserInfo.shenasname = re.data.shomareShenasname;
        }
        this.loadingRender = false;
      });
    },
    OkCode(IdFormValid) {
      if (!this.$ValidForm(IdFormValid)) {
        return;
      }
      this.loadingRender = true;
      let Model = {
        ResultId: this.ResultStage1.data.result.id,
        ComfirmMobile: this.randomKey,
      };
      this.$PostData_new("GetInfocodeMeliByOTP", "POST", Model).then((re) => {
        if (re == null || re.result == "false" || re.result.idCode == null) {
          this.$mySweetDefaultTost(
            "خطا",
            re.result == "false"
              ? re.msg
              : "خطا در بررسی کد احراز هویت ، کد وارد شده صحیح نیست",
            "error",
            4800,
          );
          this.loadingRender = false;
          this.stage = 2;
          return;
        }
        if (re.result.id != null && re.result.id.trim() != "") {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            "احراز موفق",
            "کاربر گرامی : " +
              re.result.name +
              " " +
              re.result.family +
              " احراز هویت شما با موفقیت انجام گردید ",
            "success",
            4800,
          );
          this.stage = 3;
          this.ResultStage2 = re;
          this.EstlamSuccess = true;
          this.FixInput = true;
          this.UserInfo.ozvName = re.result.name;
          this.UserInfo.ozvFamily = re.result.family;
          this.UserInfo.codeMeli = re.result.idCode;
          this.UserInfo.birthDate = re.result.birthDate;
          this.UserInfo.mobile = re.result.mobile;
          this.UserInfo.pedar = re.result.fatherName;
          this.UserInfo.shenasname = re.result.nationalId;
        } else {
          this.$mySweetDefaultTost(
            "عملیات ناموفق",
            "خطایی رخ داد است",
            "error",
            2000,
          );
          this.loadingRender = false;
        }
        this.loadingRender = false;
      });
    },
    LogOut() {
      var DataAxios = {
        Method: "Post",
        Action: "Logout",
        ArryfildValue: {},
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxios).then((result) => {
        //console.log(result);
        this.$store.state.Netpa_Cart = [];
        this.$store.state.AzaPicSrc = "";
        this.$store.state.AzaPicId = null;
        this.$router.push("/");
        this.$session.clear();
        sessionStorage.removeItem("vuex");
        this.$store.state.PanelRout = [];
        this.$ResetTimer();
      });
    },
  },
  computed: {
    UserTabs() {
      const tabs = [];
      if (this.showTab(0)) tabs.push({ id: "nav-home", title: "اطلاعات هویتی" });
      if (this.showTab(1))
        tabs.push({ id: "nav-BankAccount", title: "حساب‌های بانکی" });
      if (this.showTab(3)) tabs.push({ id: "nav-file", title: "بارگذاری مدارک" });
      if (this.showTab(4)) tabs.push({ id: "nav-Isar", title: "وضعیت ایثارگری" });
      return tabs;
    },
    avatarSrc() {
      return this.$store.state.AzaPicSrc || this.defaultAvatar;
    },
  },
  props: {
    NeedEstelam: {
      default: "false",
    },
  },
};
</script>
<style>
#UserInfo .user-info-change-pass-content {
  width: 100%;
}

#UserInfo .user-info-change-pass-alert {
  margin-bottom: 1rem;
  text-align: right;
}

#UserInfo .user-info-change-pass-alert__list {
  list-style: decimal;
  padding-right: 1.25rem;
  font-size: 14px;
}

#UserInfo .user-info-change-pass-form {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  direction: rtl;
}

#UserInfo .user-info-change-pass-field {
  margin-bottom: 0.75rem;
}

#UserInfo .user-info-change-pass-actions {
  margin-top: 1rem;
}

#UserInfo .user-info-change-pass-submit-btn {
  width: 100%;
  min-height: 40px;
  border-radius: 8px;
  font-weight: 600;
}

#UserInfo .user-info-auth-form {
  max-width: 520px;
  margin-inline: auto;
  padding-inline: 0.5rem;
}

#UserInfo .user-info-avatar-wrap {
  display: flex;
  justify-content: center;
}

#UserInfo .user-info-avatar {
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid #e8ecf1;
  box-shadow: 0 1px 4px rgba(42, 63, 84, 0.08);
  background: #f8f9fb;
}

#UserInfo .user-info-identity-fields .form-control {
  text-align: right;
}

#UserInfo .user-info-identity-fields .form-control::placeholder {
  text-align: right;
  direction: rtl;
}

#UserInfo .user-info-identity-fields .form-control.text-left,
#UserInfo .user-info-identity-fields .form-control.required-CodeMeli {
  direction: ltr;
  text-align: left;
}

#UserInfo .user-info-identity-fields .form-control.text-left::placeholder,
#UserInfo
  .user-info-identity-fields
  .form-control.required-CodeMeli::placeholder,
#UserInfo .user-info-identity-fields .form-control[dir="ltr"]::placeholder {
  text-align: right;
  direction: rtl;
}

#UserInfo
  .user-info-identity-fields
  .vpd-input-group
  input.form-control::placeholder {
  text-align: right;
  direction: rtl;
}

#UserInfo .user-info-identity-fields .vpd-main {
  display: block;
  width: 100%;
}

#UserInfo .user-info-identity-fields .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(42, 63, 84, 0.07);
  overflow: hidden;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#UserInfo .user-info-identity-fields .vpd-input-group:focus-within {
  border-color: #c5ced9;
  box-shadow: 0 2px 8px rgba(42, 63, 84, 0.1);
}

#UserInfo .user-info-identity-fields .vpd-input-group input,
#UserInfo .user-info-identity-fields .vpd-input-group input.form-control {
  flex: 1 1 auto;
  min-width: 0;
  height: 38px;
  min-height: 38px;
  margin: 0;
  padding: 0.375rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent;
}

#UserInfo .user-info-identity-fields .vpd-input-group input:focus {
  outline: none;
  box-shadow: none !important;
}

#UserInfo .user-info-identity-fields .vpd-input-group .vpd-icon-btn {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  margin: 0;
  padding: 0 0.65rem;
  border: none;
  border-radius: 0;
  border-inline-start: 1px solid rgba(255, 255, 255, 0.28);
}

#UserInfo .user-info-auth-form .vpd-main {
  display: block;
  width: 100%;
}

#UserInfo .user-info-auth-form .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(42, 63, 84, 0.07);
  overflow: hidden;
}

#UserInfo .user-info-auth-form .vpd-input-group input {
  flex: 1 1 auto;
  min-width: 0;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent;
}

#UserInfo .user-info-auth-form .vpd-input-group .vpd-icon-btn {
  flex: 0 0 auto;
  border: none;
  border-radius: 0;
  border-inline-start: 1px solid rgba(255, 255, 255, 0.28);
}

#UserInfo .user-info-docs-tab {
  padding-top: 0;
}

#UserInfo .user-info-docs-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

#UserInfo .user-info-doc-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 0;
  min-height: 0;
  padding: 12px;
  border: 1px solid #e8eef2;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(31, 42, 79, 0.08);
}

#UserInfo .user-info-doc-card .container-fluid {
  width: 100%;
  padding: 0;
}

#UserInfo .user-info-doc-card .container-fluid > .row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin: 0;
}

#UserInfo .user-info-doc-card .container-fluid > .row > [class*="col-"] {
  padding-left: 0;
  padding-right: 0;
}

#UserInfo .user-info-doc-card .container-fluid > .row > .col-12.text-center {
  display: flex;
  flex: 0 0 160px;
  align-items: center;
  justify-content: center;
  width: 160px;
  max-width: 160px;
  min-height: 160px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: transparent;
}

#UserInfo
  .user-info-doc-card
  .container-fluid
  > .row
  > .col-12:not(.text-center) {
  flex: 1 1 auto;
  width: auto;
  max-width: none;
  min-width: 0;
}

#UserInfo .user-info-doc-card .col-12.text-center img,
#UserInfo .user-info-doc-card .col-12.text-center img.w-100 {
  display: block;
  width: 160px !important;
  height: 160px !important;
  max-width: 160px !important;
  max-height: none !important;
  object-fit: contain;
  border-radius: 0;
}

#UserInfo .user-info-doc-card .col-12.p-3.text-center.font-weight-bold {
  padding: 0 !important;
  margin: 0;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.7;
  color: #13243a;
  text-align: right;
}

#UserInfo .user-info-doc-card .col-12.p-3.text-center.font-weight-bold .fas {
  font-size: 14px;
}

@media (min-width: 992px) {
  #UserInfo .user-info-docs-grid {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
}

@media (max-width: 480px) {
  #UserInfo .user-info-doc-card .container-fluid > .row > .col-12.text-center {
    flex-basis: 120px;
    width: 120px;
    max-width: 120px;
    min-height: 120px;
  }

  #UserInfo .user-info-doc-card .col-12.text-center img,
  #UserInfo .user-info-doc-card .col-12.text-center img.w-100 {
    width: 120px !important;
    height: 120px !important;
    max-width: 120px !important;
  }
}

#UserInfo .user-info-bank-form {
  align-items: center;
  margin-top: 0.5rem;
}

#UserInfo .user-info-bank-field {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 0.75rem;
}

#UserInfo .user-info-bank-label {
  display: block;
  margin-bottom: 0.35rem;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  color: #6c757d;
}

#UserInfo .user-info-bank-field .user-info-bank-input,
#UserInfo .user-info-bank-field select.form-control {
  height: 38px;
  min-height: 38px;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
}

#UserInfo .user-info-sheba-input {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  direction: ltr;
}

#UserInfo .user-info-sheba-prefix {
  flex: 0 0 auto;
  margin: 0;
  padding: 0 0.1rem 0 0;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 38px;
  color: #2a3f54;
}

#UserInfo .user-info-sheba-input .user-info-bank-input {
  flex: 1 1 auto;
  min-width: 0;
}

#UserInfo .user-info-bank-add {
  width: 100%;
  padding-top: 0.25rem;
}

#UserInfo .user-info-bank-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0.625rem;
  width: 100%;
  margin-top: 1rem;
  padding-top: 0.875rem;
  border-top: 1px solid #e8ecf1;
  box-sizing: border-box;
}

#UserInfo .user-info-bank-actions__btn {
  flex: 1 1 calc(50% - 0.3125rem);
  min-width: 0;
  height: 40px;
  margin: 0;
  padding: 0.5rem 1rem;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
}

@media (min-width: 576px) {
  #UserInfo .user-info-bank-actions {
    flex-wrap: nowrap;
    justify-content: flex-end;
    max-width: 360px;
    margin-inline-start: auto;
    margin-inline-end: 0;
  }

  #UserInfo .user-info-bank-actions__btn {
    flex: 1 1 0;
    min-width: 120px;
  }
}

@media (max-width: 575px) {
  #UserInfo .user-info-bank-actions {
    flex-direction: column;
  }

  #UserInfo .user-info-bank-actions__btn {
    flex: none;
    width: 100%;
  }
}
</style>
<style scoped>
.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(
    301deg,
    rgba(145, 124, 193, 1) 0%,
    rgba(72, 20, 193, 1) 100%
  );
  /* background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%,#403c47 100%); */
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>
